require('/opt/odin/app/frontend/pages/guides/components/v2_resources/index.module.scss');module.exports = "../../app/cells/pages/guides/v2_resources/show.erb";